import { render, staticRenderFns } from "./FRangeSliderSPA.vue?vue&type=template&id=21af1470&"
import script from "./FRangeSliderSPA.vue?vue&type=script&lang=ts&"
export * from "./FRangeSliderSPA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports